import { render } from "./P028.vue?vue&type=template&id=7b58f1ae&scoped=true"
import script from "./P028.vue?vue&type=script&lang=js"
export * from "./P028.vue?vue&type=script&lang=js"

import "./P028.vue?vue&type=style&index=0&id=7b58f1ae&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b58f1ae"]])

export default __exports__